import axios from 'axios';

export const companiesApi = axios.create({
  baseURL: 'https://download.bedrijfsdata.nl/v1'
});

companiesApi.interceptors.request.use((config) => {

    const token = 'olivier_345@$';
    const defaultParams = {
        front: 1,
        token_fixed: token,
        db: 'reg'
    };

    config.params = { 
        ...defaultParams,
        ...config.params
    };

    return config;
});

companiesApi.interceptors.response.use(
    response => response,
    error => {
        return Promise.reject(error);
    }
);

export const fetchCompanies = async (params = {}) => companiesApi.get('/companies', { params });
